module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_06.4a730a1e.png";